export const AUTO_START_STATE_ENABLED = 'ENABLE';
export const AUTO_START_STATE_DISABLE = 'DISABLE';
